<template>  
    <mu-appbar class="XR-head" :title="titleTextValue">
        <mu-icon-button v-if="leftShowValue" v-on:click="GoHistory" icon=":fa fa-angle-left" slot="left"/>
        <mu-icon-menu v-if="rightShowValue" icon=":fa fa-mymore" slot="right">
          <mu-menu-item to="/usercenter/index" title="个人中心"/>
          <mu-menu-item to="/" title="首页"/>
          <mu-menu-item to="/retail/cart" title="购物车"/>
        </mu-icon-menu>
    </mu-appbar>
</template>
<script>
export default {
  name : 'XR-head',
  data () {
    return {
      titleTextValue: this.titleText
    }
  },
  props:{
    titleText: String,
    leftShow: {
      type: Boolean,
      default: true
    },
    rightShow : Boolean
  },
  computed:{
    leftShowValue: function(){
      return this.leftShow
    },
    rightShowValue: function(){
      return typeof(this.rightShow) == "boolean" ? this.rightShow : true
    },
  },
  methods: {
    GoHistory(){
      this.$router.goBack()
    },
    UpdateTitle(val){
      this.titleTextValue = val
    }
  }
}
</script>

<style>
.XR-head .mu-appbar{
  height: 46px;
  text-align: center;
}
.XR-head .mu-appbar.fixed{  
  padding:0;
  position: fixed;
  top:0;
  left: 0;
}
.XR-head .mu-appbar-title {
  font-size: 16px;
}
.XR-head .title .mu-icon-button {
  position: absolute;
  left: 0;
  top: 0;
  color:white;
}
.XR-head .title .title-text {
  margin: 0;
  line-height: 48px;
}
</style>



// WEBPACK FOOTER //
// src/components/usercenter/head/head.vue